import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, API } from "@/lib/api";

export const useUsersLite = () =>
  useQuery({ queryKey: ["users-lite"], queryFn: async () => (await api.get("/users/lite")).data, staleTime: 120_000 });

export const useUserMap = () => {
  const { data = [] } = useUsersLite();
  return useMemo(() => Object.fromEntries(data.map((u) => [u.id, u])), [data]);
};

export const useAssignableOptions = () => {
  const { data = [] } = useUsersLite();
  return useMemo(
    () => data.filter((u) => u.active && u.role !== "accounts").map((u) => ({ value: u.id, label: u.name })),
    [data],
  );
};

export const useBranding = () =>
  useQuery({ queryKey: ["branding"], queryFn: async () => (await api.get("/settings/public")).data, staleTime: 300_000 });

export const logoSrc = (v) => `${API}/settings/logo?v=${v}`;
